import { useState, useCallback } from 'react';
import ProtocolFieldsService from '../../service';
import { toast } from 'react-toastify';

function useHandleProtocolListing(recordTypeId) {
  const [protocols, setProtocols] = useState(null);
  const [protocolsQuantity, setProtocolQuantity] = useState(0);
  const [isLoadingProtocols, setIsLoadingProtocols] = useState(false);
  const [protocolOverallSLAInfo, setProtocolOverallSLAInfo] = useState(null);

  const getProtocols = useCallback(
    async (params = {}, showToastMessage = true) => {
      if (!recordTypeId) return;
      setIsLoadingProtocols(true);
      if (params.matrixSLA) {
        params.matrixSLA = params.matrixSLA.value;
      }

      ProtocolFieldsService.getProtocolsByRecordType(recordTypeId, params)
        .then((response) => {
          const protocolsData = response.data.content;
          const quantity = response.data.quantity;
          setProtocols(protocolsData);
          setProtocolQuantity(quantity);
          if (quantity === 0 && showToastMessage) {
            toast.error('Nenhum registro foi encontrado', {
              autoClose: 3000,
              closeOnClick: true
            });
          }
        })
        .catch(() => {
          setProtocols(null);
        })
        .finally(() => {
          setIsLoadingProtocols(false);
        });
    },
    [recordTypeId]
  );

  const cleanObject = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        // eslint-disable-next-line no-unused-vars
        ([_, v]) =>
          v !== null && v !== '' && (!Array.isArray(v) || v.length > 0)
      )
    );
  };

  const getProtocolOverallSLAInfoByRecordType = useCallback(
    (params = {}) => {
      if (params.matrixSLA) {
        params.matrixSLA = params.matrixSLA.value;
      }
      params = cleanObject(params);
      ProtocolFieldsService.getProtocolOverallSLAInfoByRecordType(
        recordTypeId,
        params
      )
        .then((response) => {
          const data = response.data.content;
          setProtocolOverallSLAInfo(data);
        })
        .catch(() => {
          setProtocolOverallSLAInfo(null);
        });
    },
    [recordTypeId]
  );

  const getAndReturnProtocols = useCallback(
    (params = {}) => {
      return ProtocolFieldsService.getProtocolsByRecordType(
        recordTypeId,
        params
      );
    },
    [recordTypeId]
  );

  return {
    protocols,
    protocolsQuantity,
    isLoadingProtocols,
    getProtocols,
    getAndReturnProtocols,
    getProtocolOverallSLAInfoByRecordType,
    protocolOverallSLAInfo
  };
}

export { useHandleProtocolListing };
